import { createSelector } from '@ngrx/store';
import { availablePickupsState } from '../root';

export const isCalculatingAvailablePickups = createSelector(
    availablePickupsState,
    availablePickups => availablePickups.some(obj => obj.isCalculating === true)
);
